
import React, { Component } from 'react'
import * as actions from "../actions";
import { hydratePhotoPosts } from "../../photos/actions";

import FetchingContent from "../../common/components/fetching-content";
import MountComponentOnBody from "../../common/components/mount-component-on-body";
import SlideshowComments from "./slideshow-comments";
import SlideshowDetails from "./slideshow-details";
import SlideshowOverlayAd from "./slideshow-overlay-ad";
import Swipeshow from "./swipeshow";
import { connect } from 'react-redux';

const Slideshow = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    return this.props.state.slideshow.isOpen || nextProps.state.slideshow.isOpen;
  },
  componentDidUpdate(prevProps, prevState) {
    // Attach/remove a keyup event depending on whether the slideshow is open
    if (this.props.state.slideshow.isOpen) {
      if (!prevProps.state.slideshow.isOpen) {
        // When slideshow opens
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.setTimeout(function() {
          /*  Timeout covers fade in animation for gallery. Otherwise the page
            jump is visible before the gallery opens on mobile. */
          $('html').addClass('slideshow-open');
          $(window).resize();
        }, 500);
        document.addEventListener('keyup', this.handleDocKeyUp, false);
        if (!this.props.state.photos.hydrated) {
          hydratePhotoPosts();
        }
      }
    } else {
      $('html').removeClass('slideshow-open');
      window.scrollTo(0, this.scrollTop);
      document.removeEventListener('keyup', this.handleDocKeyUp, false);
    }
  },
  render() {
    const slideshow = this.props.state.slideshow;
    if (!slideshow.isOpen) {
      return null;
    }
    // We store the current slide as a postid in the store.
    // We need to find the index of that post within the photos store
    // in order to use it in the slideshow.
    const { postId, commentsVisible, overlayAdVisible } = slideshow;
    const photos = this.props.state.photos;
    let slideIndex = photos.objects.map(function(e) {
        return e.id;
      }).indexOf(postId);
    if (slideIndex === -1) {
      slideIndex = 0;
    }
    const post = photos.objects[slideIndex];
    const galleryClass = `event-view event-gallery ${commentsVisible ? 'comments-active' : ''}`;
    return (
      <MountComponentOnBody componentId="root-slideshow">
        <div
          className={galleryClass}
          tabIndex="1"
          style={{display: "block"}}
          onClick={this.handleOutsideClick}
        >
          <div className="event-gallery-wrap">
            <div className="event-gallery-inner" onClick={this.handleInsideClick}>
              { photos.fetchingPhotos ?
                <FetchingContent fetching="photos" />
              :
                <Swipeshow photos={photos} slideIndex={slideIndex} />
              }
              <div className="feed-post post-panel">
                <SlideshowDetails post={post} />
                <SlideshowComments post={post} />
              </div>
              <SlideshowClose />
              { overlayAdVisible &&
                <SlideshowOverlayAd />
              }
            </div>
          </div>
        </div>
      </MountComponentOnBody>
    );
  },
  handleOutsideClick(e) {
    actions.closeSlideshow();
  },
  handleInsideClick(e) {
    e.stopPropagation();
  },
  goPrevSlide() {
    $('.swipeshow').swipeshow().previous();
  },
  goNextSlide() {
    $('.swipeshow').swipeshow().next();
  },
  handleDocKeyUp(e) {
    const { overlayAdVisible } = this.props.state.slideshow;
    const focusIsInput = document.activeElement.type === 'text' || document.activeElement.isContentEditable;
    const allowSlideNavigation = !overlayAdVisible && !focusIsInput;
    switch (e.keyCode) {
      case 27:
        //  ESC: Close slideshow
        actions.closeSlideshow();
        break;
      case 37:
        // Left arrow: go previous slide
        if (allowSlideNavigation) {
          this.goPrevSlide();
        }
        break;
      case 39:
        // Right arrow: go next slide
        if (allowSlideNavigation) {
          this.goNextSlide();
        }
        break;
    }
  }
});

const SlideshowClose = React.createClass({
  shouldComponentUpdate() {
    return false;
  },
  render() {
    return (
      <a href="#" className="slideshow-close" onClick={this.onCloseClick}>
        <span className="close-icon">&times;</span>
        <span className="close-text">Close</span>
      </a>
    )
  },
  onCloseClick(e) {
    e.preventDefault();
    actions.closeSlideshow();
  }
});

function mapStateToProps(state) {
  return {
    state: {
      photos: state.photos,
      slideshow: state.slideshow
    }
  }
}

const connectedSlideshow = connect(mapStateToProps)(Slideshow);

export default connectedSlideshow;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/slideshow/components/index.es6